import api, { unwrap } from './client';

/* Correspondances libellé source → offre (2026-10-22). Le libellé d'une ligne de réalisé collée depuis l'outil du
   client se rattache à son offre ; « ignorer » écarte un libellé qui n'entre dans aucune offre. */
// Les libellés connus : d'abord ceux à rattacher, puis les correspondances posées.
export const getSourceMaps = (tenantId) => unwrap(api.get(`/sales-source-maps/${tenantId}`));
// Pose ou change la correspondance d'un libellé : { label, offer_id } ou { label, ignored: true }.
export const putSourceMap = (tenantId, payload) => unwrap(api.put(`/sales-source-maps/${tenantId}`, payload));
export const deleteSourceMap = (tenantId, mapId) => unwrap(api.delete(`/sales-source-maps/${tenantId}/${mapId}`));
